<template>
  <div class="helpdesk">
    <div class="helpdesk__intro">
      <Intro
        heading="Behöver du hjälp?"
        description="Något gick fel med din anmälan. Försök igen, eller kontakta kundservice på <em class='uiNoWrap'>08-82 00 00</em> om du vill ha vår hjälp. Vi har öppet vardagar 8-17."
      />
    </div>
    <ul class="helpdesk__btnList">
      <li class="helpdesk__btnItem">
        <a class="btn btn--wide btn--blueOutline" href="https://www.vattenfall.se/kundservice/" target="_blank">Fler kontaktvägar</a>
      </li>
      <li class="helpdesk__btnItem" v-if="!this.$store.state.progress.completed">
        <router-link class="btn btn--wide" :to="{ name: 'Start' }">Testa igen</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import Intro from '@/templates/components/Intro'

export default {
  name: 'Helpdesk',
  components: {
    Intro
  },
  data () {
    return {
      msg: 'Helpdesk view'
    }
  },
  computed: {
    user: function () {
      return window.user
    }
  },
  mounted: function () {
    window.scrollTo(0, 0)
    console.log('Thanks, reset user')
    this.$store.commit('user/reset')
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/views/Helpdesk/index.vue